import { Transfer } from "antd"
import { useEffect, useMemo, useState } from "react";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { DiscountCardTypeProvider } from "../../../../../Services/DataProviders/DiscountCardTypeProvider";
import { IDiscountCardTypeFormViewDTO } from "../../../../../libs/coreapi-dto/dirs/discountCardType";
import { Spinner } from "../../../../../components/spiner/Spinner";
import { ITransferTypeCardsProps, RecordType } from "../../interface";

const TransferTypeCards: React.FC<ITransferTypeCardsProps> = ({
    value = [],
    onChange,
}) => {
    const appCtx = useAppContext()
    const discountCardTypeProvider = new DiscountCardTypeProvider(appCtx.coreApiService);

    const [allTypeCardsData, setAllTypeCardsData] = useState<IDiscountCardTypeFormViewDTO[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const gridFilterTypeCards: IGridFilter = {
        numberPerPage: 15,
        pageNumber: 1,
        columnFilters: [
            {
                name: "deleted",
                operator: "Eq",
                value: false,
            }
        ]
    };

    const transformDataToTransferFormat = (cardTypes: IDiscountCardTypeFormViewDTO[]): RecordType[] => {
        return cardTypes.map(cardType => ({
            key: cardType.idGlobal,
            title: cardType.name || 'Без названия',
        }));
    };

    const filteredTransferData = useMemo(() => {

        const allData = transformDataToTransferFormat(allTypeCardsData);

        return allData.filter(item =>
            !value.includes(item.key))

    }, [allTypeCardsData, value]);

    const selectedTypeCardsInfo = useMemo(() => {
        return allTypeCardsData
            .filter(typeCard =>
                value.includes(typeCard.idGlobal)
            )
            .map(typeCard => ({
                key: typeCard.idGlobal,
                title: typeCard.name || 'Без названия',
            }));
    }, [allTypeCardsData, value]);

    const transferDataSource = useMemo(() => {
        return [...filteredTransferData, ...selectedTypeCardsInfo];
    }, [filteredTransferData, selectedTypeCardsInfo]);

    useEffect(() => {
        setIsSubmitting(true)
        discountCardTypeProvider.getView(gridFilterTypeCards, (data, totalCount) => {
            if (totalCount > gridFilterTypeCards.numberPerPage) {
                const allDataFilter = { ...gridFilterTypeCards, numberPerPage: totalCount, pageNumber: 1 };
                discountCardTypeProvider.getView(allDataFilter, (data) => {
                    setAllTypeCardsData(data);
                    setIsSubmitting(false);
                });
            } else {
                setAllTypeCardsData(data);
                setIsSubmitting(false);
            }
            setAllTypeCardsData(data);
            setIsSubmitting(false);
        })
    }, [])

    const filterOption = (inputValue: string, option: RecordType) =>
        option.title.toLowerCase().includes(inputValue.toLowerCase())

    const handleChange = (newTargetKeys: string[]) => {
        if (onChange) {
            onChange(newTargetKeys);
        }
    };

    if (isSubmitting) {
        return <Spinner />;
    }

    return (
        <Transfer
            dataSource={transferDataSource}
            targetKeys={value}
            onChange={handleChange}
            render={item => `${item.title}`}
            showSearch
            filterOption={filterOption}
            listStyle={{
                width: 900,
                height: 500
            }}
            pagination
        />
    )
}

export default TransferTypeCards